import * as go from 'gojs';
import { TEXT_COLOR_PROP, TEXT_PROP } from '../../common/config/common-prop-names';
import { textMargin } from '../config/config';
import { STICKY_NODE_MAIN_SHAPE } from './../config/part-names';

export const textBinding = () => new go.Binding('text', TEXT_PROP).makeTwoWay();

export const textColorBinding = () => new go.Binding('stroke', TEXT_COLOR_PROP);

export const textBlockSizeBinding = () =>
  new go.Binding(
    'maxSize',
    'desiredSize',
    ({ width, height }: go.Size) => new go.Size(width - textMargin * 2, height - textMargin * 2),
  ).ofObject(STICKY_NODE_MAIN_SHAPE);
